import React from "react";
import { NavLink } from "react-router-dom";

export function TopTabs({ tabs, value, onChange }) {
  return (
    <div className="sm-topbar overflow-x-auto whitespace-nowrap" data-testid="top-tabs">
      {tabs.map((t) => t.to ? (
        <NavLink key={t.label} to={t.to} data-testid={`tab-${t.label.toLowerCase()}`}
          className={({ isActive }) => `sm-tab ${isActive ? "active" : ""}`}>{t.label}</NavLink>
      ) : (
        <button key={t.label} type="button" data-testid={`tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
          onClick={() => onChange?.(t.label)} className={`sm-tab ${value === t.label ? "active" : ""}`}>{t.label}{t.badge != null ? <span className={`ml-1.5 inline-flex items-center justify-center rounded-full px-1.5 text-[10px] font-semibold ${value === t.label ? "bg-[#0b1f3a] text-white" : "bg-slate-200 text-slate-700"}`}>{t.badge}</span> : null}</button>
      ))}
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, actions, tabs }) {
  return (
    <div className="bg-white border-b border-slate-200">
      {tabs ? <TopTabs tabs={tabs} /> : null}
      <div className="px-4 sm:px-7 py-4 sm:py-5 flex flex-col sm:flex-row sm:items-start justify-between gap-3 sm:gap-6">
        <div className="min-w-0">
          {eyebrow ? <div className="text-[11px] uppercase tracking-wider text-slate-500 mb-0.5">{eyebrow}</div> : null}
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
          {description ? <p className="mt-1 text-sm text-slate-500 max-w-2xl hidden sm:block">{description}</p> : null}
        </div>
        {actions ? <div className="flex items-center gap-2 shrink-0 flex-wrap">{actions}</div> : null}
      </div>
    </div>
  );
}
